// extracted by css-extract-rspack-plugin
export default {"logo":"Logo_logo__Pgit5"};